import { isAfter, isBefore } from 'date-fns';
export const isDisabled = (day, minDate, maxDate)=>{
    return !!minDate && isBefore(day, minDate) || maxDate && isAfter(day, maxDate);
};
